export function isTruthy(value) {
    return !!value;
}
export function cleanArray(array) {
    return array.filter(isTruthy);
}
//# sourceMappingURL=cleanArray.js.map